import { useEffect, useState } from "react";
import API from "../lib/api";
import { Input } from "./ui/input";
import { Badge } from "./ui/badge";
import { Button } from "./ui/button";

const fmt = (iso) => (iso ? new Date(iso).toLocaleString("en-GB", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit", second: "2-digit" }) : "—");

export function EmailLogTable({ refreshKey }) {
  const [status, setStatus] = useState("all");
  const [q, setQ] = useState("");
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let alive = true;
    setLoading(true);
    const h = setTimeout(() => {
      API.get("/platform/email-health/log", { params: { status, q, limit: 150 } })
        .then(({ data }) => { if (alive) setRows(data.items); })
        .catch(() => {})
        .finally(() => alive && setLoading(false));
    }, 250);
    return () => { alive = false; clearTimeout(h); };
  }, [status, q, refreshKey]);

  return (
    <div className="rounded-lg border border-border bg-card" data-testid="email-log">
      <div className="flex items-center justify-between gap-3 flex-wrap p-4 border-b border-border">
        <h2 className="text-base font-semibold">Outbound e-mail log</h2>
        <div className="flex items-center gap-2">
          {["all", "sent", "failed"].map((s) => (
            <Button key={s} size="sm" variant={status === s ? "default" : "outline"} className="h-7 text-xs capitalize" onClick={() => setStatus(s)} data-testid={`email-log-filter-${s}`}>{s}</Button>
          ))}
          <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search recipient or subject" className="h-7 w-56 text-xs" data-testid="email-log-search" />
        </div>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-xs">
          <thead className="bg-muted/40 text-left">
            <tr>{["When", "To", "Subject", "Kind", "Via", "Result"].map((h) => <th key={h} className="px-3 py-2 font-semibold text-muted-foreground uppercase tracking-wide text-[10px]">{h}</th>)}</tr>
          </thead>
          <tbody>
            {rows.length === 0 && (
              <tr><td colSpan={6} className="px-3 py-6 text-center text-muted-foreground" data-testid="email-log-empty">{loading ? "Loading…" : "No e-mails logged yet — the log fills as the app sends mail."}</td></tr>
            )}
            {rows.map((r, i) => (
              <tr key={`${r.at}-${i}`} className="border-t border-border/60" data-testid="email-log-row">
                <td className="px-3 py-2 whitespace-nowrap text-muted-foreground">{fmt(r.at)}</td>
                <td className="px-3 py-2 whitespace-nowrap">{r.to}</td>
                <td className="px-3 py-2 max-w-[360px] truncate" title={r.subject}>{r.subject}</td>
                <td className="px-3 py-2 whitespace-nowrap"><Badge variant="outline" className="text-[10px] font-mono">{r.kind || "other"}</Badge></td>
                <td className="px-3 py-2 whitespace-nowrap text-muted-foreground">{r.provider || "—"}{r.ms ? ` · ${(r.ms / 1000).toFixed(1)}s` : ""}</td>
                <td className="px-3 py-2">
                  {r.accepted ? <Badge className="bg-emerald-100 text-emerald-700 text-[10px]">sent</Badge>
                    : <span className="inline-flex items-center gap-1"><Badge className="bg-red-100 text-red-700 text-[10px]">failed</Badge><span className="text-red-700 dark:text-red-300 max-w-[260px] truncate" title={r.error}>{r.error}</span></span>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
